import React from "react";
import { useEffect, useState } from "react";
import { Button, TextField, FormControlLabel, Checkbox, Typography } from '@mui/material';
import Axios from "axios";
import { apiPath } from "../services/const";
import PasswordRequirementsDialog from "../Components/passwordRecoveryDialog.jsx"

function PasswordRecoveryConfirm({sendDataToParent, token, classes }){


    const [input, setInput] = useState({
        password:"",
        passwordConfirm:"",
    });

    const [showPassword, setShowPassword] = useState(false)

    const [state, setState] = useState({
        login: "",
        name: "",
        passwordRequirementOk: true,
    })

    const handleChildData = (data) =>{
        setState({...state, ...data})
    }

    const updatePassword = (event) =>{
        setInput({...input, password:event.target.value})
    }
    const updatePasswordConf = (event) =>{
        setInput({...input, passwordConfirm:event.target.value})
    }
    const handleShowPassword = () => {
        setShowPassword(!showPassword)
    }

    const get_user_data = (tok) =>{
        return Axios.get(`${apiPath}/users/password-reset/confirm`,{
            params:{
                'token':tok,
            }
        })
    }

    const SendConfirmation = (tok, pass) =>{
        return Axios.post(`${apiPath}/users/password-reset/confirm`,{},{
            params:{
                'token':tok,
                'new_password':pass
            }
        })
    }

    const handleSendConfirmationClick = () => {
        if (input.password === input.passwordConfirm){
            SendConfirmation(token, input.password)
            .then(response => {
                if (response.status === 201){
                    sendDataToParent({msg:"Senha alterada com Sucesso", fase:3, emailOk:true})
                }
            })
            .catch(err => {
                if (err.response){
                    sendDataToParent({msg:err.response.data.detail})
                } else{
                    sendDataToParent({msg:"Houve um problema de conexão com o servidor. Tente novamente mais tarde"})
                }
            })

        }
    }

    useEffect(()=>{
        get_user_data(token).then( r=> {
            setState({
                login: r.data.login,
                name: r.data.name
            })
        }).catch(err =>{
            switch ( err.response?.status){
                case 403:
                    sendDataToParent({msg:err.response.data.detail, emailOk:false})
                    break
                    case 400:
                        alert(err.response.data.detail)
                        window.location.href = "/"
                        break
                        default:
                            alert('Houve algum problema ')
                            window.location.href = "/"
                            break
                            
                        }
                    });
                    // eslint-disable-next-line
    },[token])

    return(
        <>
        <div>
            <Typography variant="h5" className={classes.title}>Escolha uma senha</Typography>
            <Typography variant="body2" className={classes.text}>Insira uma nova senha para o usuário </Typography>
            <Typography variant="body2"><b>{state.login} - {state.name}</b></Typography>
            <div className={classes.inputBox}>
                {/* Nova senha: */}
                <TextField variant="outlined" required fullWidth id="password" name="passsword"
                type={(showPassword? "text" : "password")} autoComplete="none"
                label={'Nova senha'}
                onChange={(e)=>updatePassword(e)} />
                {/* Confirmar senha: */}
                <TextField variant="outlined" required fullWidth id="password" name="password"
                    type={(showPassword? "text" : "password")} autoComplete="none"
                onChange={(e)=>updatePasswordConf(e)} 
                label={'Confirmar senha'}
                />
                <FormControlLabel control={<Checkbox checked={showPassword} onChange={() =>handleShowPassword()} />} label="Mostrar senha" />
                <PasswordRequirementsDialog sendDataToParent={handleChildData} password={input.password} passwordConfirm={input.passwordConfirm} />
                <Button fullWidth variant="contained" className={classes.button} disabled={!state.passwordRequirementOk} color="primary" onClick={() => handleSendConfirmationClick()}>Enviar</Button>
            </div>
        </div>
        </>
    )
}

export default PasswordRecoveryConfirm